import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { FileViewOnlyCard } from "@components/FileViewOnlyCard";

import { UploadFileType } from "@type/HRM/upload-file";

export const TableColumn = (t: TFunction<"translation", undefined>) => [
  {
    id: 1,
    key: "installment",
    name: t("INSTALLMENT_DETAILS.TABLE.COLUMN.DOCUMENT"),
    render: (installment: UploadFileType[]) => (
      <FileViewOnlyCard data={installment} largeCol />
    ),
  },
  {
    id: 2,
    key: "fileName",
    name: t("INSTALLMENT_DETAILS.TABLE.COLUMN.FILE_NAME"),
    render: (fileName: number) => <Text color="subtitle1">{fileName}</Text>,
  },
  {
    id: 3,
    key: "installmentAmount",
    name: t("INSTALLMENT_DETAILS.TABLE.COLUMN.AMOUNT"),
    render: (installmentAmount: string) => (
      <Text color="subtitle1">{installmentAmount}</Text>
    ),
  },
  {
    id: 4,
    key: "date",
    name: t("INSTALLMENT_DETAILS.TABLE.COLUMN.DATE"),
    render: (date: string) => (
      <Text color="subtitle1" className="text-nowrap">
        {date}
      </Text>
    ),
  },
];
